import { render, staticRenderFns } from "./BillShareDepartmentDialog.vue?vue&type=template&id=db137852&scoped=true&"
import script from "./BillShareDepartmentDialog.vue?vue&type=script&lang=js&"
export * from "./BillShareDepartmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./BillShareDepartmentDialog.vue?vue&type=style&index=0&id=db137852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db137852",
  null
  
)

export default component.exports